import { render, staticRenderFns } from "./RecommendedManagement.vue?vue&type=template&id=18b46af8&"
import script from "./RecommendedManagement.vue?vue&type=script&lang=js&"
export * from "./RecommendedManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports